import Immutable from 'immutable'

type StatusResultProps = {
    pendingTransactionCount: number
    pspConnectionAvailable: boolean
    readyForTransaction: boolean
    transactionStatus: string
}

const StatusResultRecord = Immutable.Record({
    pendingTransactionCount: 0,
    pspConnectionAvailable: false,
    readyForTransaction: false,
    transactionStatus: null,
})

export default class StatusResult extends StatusResultRecord implements Readonly<StatusResultProps>
{
    // pendingTransactionCount: number
    // pspConnectionAvailable: boolean
    // readyForTransaction: boolean
    // transactionStatus: string
}

export const TransactionStatusCode = {
    PROCESSING: 'PROCESSING',
    WAIT_CARD_IN: 'WAIT_CARD_IN',
    WAIT_CARD_OUT: 'WAIT_CARD_OUT',
    WAIT_POS: 'WAIT_POS',
}
